import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartSheet } from "@/components/CartSheet";
import { api } from "@/lib/apiClient";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Header = () => {
  const navigate = useNavigate();
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    api.get("/settings").then((res) => setLogo(res.data.logo_url)).catch(() => {});
  }, []);

  return (
    <header className="sticky top-0 z-50 border-b border-ashy/30 bg-cream/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 leading-none">
          {logo ? (
            <img src={`${BACKEND_URL}${logo}`} alt="Alexis's Sweet Treats" className="h-12 w-auto object-contain" data-testid="site-logo" />
          ) : (
            <span className="flex flex-col">
              <span className="font-heading text-xl font-black tracking-tight text-cocoa md:text-2xl">Alexis's</span>
              <span className="-mt-1 text-xs font-medium uppercase tracking-[0.3em] text-ashydark">Sweet Treats</span>
            </span>
          )}
        </Link>

        <nav className="hidden items-center gap-8 text-sm font-medium text-ink md:flex">
          <button onClick={() => navigate("/")} className="transition-colors hover:text-cocoa" data-testid="nav-home">Home</button>
          <a href="/#flavors" className="transition-colors hover:text-cocoa" data-testid="nav-flavors">Flavors</a>
          <a href="/#bundles" className="transition-colors hover:text-cocoa" data-testid="nav-bundles">Build a Box</a>
          <a href="/#contact" className="transition-colors hover:text-cocoa" data-testid="nav-contact">Contact</a>
          <a href="/#pickup" className="transition-colors hover:text-cocoa" data-testid="nav-pickup">Pickup</a>
        </nav>

        <CartSheet />
      </div>
    </header>
  );
};
